import { enqueueModalAtom } from '@/atoms/modalQueueAtoms';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { HCP_VERIFICATION_OPEN_QUEUE_ITEM } from './hcp-verification-atoms';

/**
 * Opens the clinician (NPI) verification dialog on demand by enqueueing the
 * CRITICAL user-triggered item. Idempotent — the queue dedupes by id.
 */
export const useOpenHcpVerificationModal = () => {
  const enqueue = useSetAtom(enqueueModalAtom);
  return useCallback(() => enqueue(HCP_VERIFICATION_OPEN_QUEUE_ITEM), [enqueue]);
};
